// extracted by mini-css-extract-plugin
module.exports = {"lightSubTitle":"SectionLabel_lightSubTitle__1kywb"};